import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import { phaseApis } from "../../api/Phase";
import { tasksApis } from "../../api/NewTasks";
import { projectsApis } from "../../api/projects";
import dayjs from "dayjs";

const BaselineVsCurrentTimelineReport = () => {
    const [statusFilterData, setStatusFilterData] = useState([]);
    const [ownerFilterData, setOwnerFilterData] = useState([]);
    const [baseLineListData, setBaseLinesListData] = useState<[]>([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { id: projectId } = location.state || {};
    const { id, derivedProjectStatus, projectName, extra } = location.state || {};

    const columns: ColumnType<any>[] = [
        {
            title: "Task Name",
            dataIndex: "taskName",
            key: "taskName",
            width: 150,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Task-${record?.taskId}`}
                            onClick={() => {

                                navigate(`/pms/project/task-detail/${record.taskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Baseline Start",
            dataIndex: "baselineStartDate",
            key: "baselineStartDate",
            width: 100,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Baseline End",
            dataIndex: "baselineEnddate",
            key: "baselineEnddate",
            width: 100,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Actual Start",
            dataIndex: "actualStartDate",
            key: "actualStartDate",
            width: 100,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Actual End",
            dataIndex: "actualEndDate",
            key: "actualEndDate",
            width: 100,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Assigned To",
            dataIndex: "assigedto",
            key: "assigedto",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Variance Days",
            dataIndex: "varianceDays",
            key: "varianceDays",
            width: 100,
            render: (text: string) => text || "N/A",
        },
        {
            title: "Critical Path",
            dataIndex: "criticalPath",
            key: "criticalPath",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
    ]


    const fetchStatusFilterData = async () => {
        try {
            const response = await projectsApis.fetchStatusFiltersByModule("Phase");
            const { data, status } = response;
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item,
                        value: item,
                    };
                });
                setStatusFilterData(options);
            }
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    const fetchOwnerFilterData = async () => {
        try {
            const response = await phaseApis.getOwnersFilterData(
                projectId?.toString()
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };
                });
                setOwnerFilterData(options);
            }
        } catch (error) {
            console.error("Error loading owner filter data:", error);
        }
    }

    const fetchBaselineNames = async () => {
        try {
            const res = await tasksApis.fetchBaselines(id);
            const { data, status } = res;
            if (status) {
                const options = data.map((item: any) => ({
                    label: item.baselineName,
                    value: item.baselineId,
                }));
                setBaseLinesListData(options);
            }
        } catch (error) {
            console.error("Failed to fetch baseline names:", error);
        }
    };



    useEffect(() => {
        fetchStatusFilterData();
        fetchOwnerFilterData();
        fetchBaselineNames();
        dispatch(
            updateMenuData([
                {
                    text: "Baseline Vs Current Timeline Report",
                    link: "pms/baseline-current-timeline-report",
                },
            ])
        );
    }, []);


    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Base Line Vs Current Timeline Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Custom Date Range",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "phaseStatus",
                            label: "Status",
                            options: statusFilterData,
                        },
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: ownerFilterData,
                        },
                        {
                            type: "multiple_selection",
                            name: "baseLineName",
                            label: "Baseline Name",
                            options: baseLineListData, 
                        }
                    ]
                }}
            />
        </>
    )
};

export default BaselineVsCurrentTimelineReport;
